import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class AdminPartingList extends ShadowDOMElement {
	static className = "AdminPartingList";
	
	static properties = {
		title: {type: String, attribute: "title"},
		textLabel : {title: String, attribute: "text-label"},
		buttonLabel : {title: String, attribute: "button-label"}
	};

	constructor() {
		super();
		this.partingAdmins = [];
		this.title = "Administrateur";
		this.textLabel = "Administrateur partant *";
		this.buttonLabel = "Ajouter un administrateur partant";
	}

	firstUpdated() {
		super.firstUpdated();
		this.addAdminPartingField();
	}

	addAdminPartingField() {
		const adminPartingField = document.createElement("admin-parting-field");
		adminPartingField.setAttribute ("title", this.title);
		adminPartingField.setAttribute ("text-label", this.textLabel);

		if (this.partingAdmins.length > 0) {
			const deleteButtonWrapper = this.createDeleteButton(() => {
				this.removeAdminPartingField(adminPartingField, deleteButtonWrapper);
			});
			this.appendChild (deleteButtonWrapper);
		}

		this.partingAdmins.push(adminPartingField);
		this.appendChild (adminPartingField);
	}

	removeAdminPartingField(adminPartingField, deleteButtonWrapper) {
		this.partingAdmins = this.partingAdmins.filter(
			(admin) => admin !== adminPartingField
		);
		this.removeChild(adminPartingField);
		if (deleteButtonWrapper)
			this.removeChild(deleteButtonWrapper);
	}

	createDeleteButton(deleteHandler) {
		const deleteButtonWrapper = document.createElement("row-wrapper");
		const deleteButton = document.createElement("button-field");

		deleteButton.onClickHandler = deleteHandler;
		deleteButton.innerHTML = `<i class="fa fa-minus"></i><span>&nbsp;Supprimer</span>`;

		deleteButtonWrapper.appendChild(deleteButton);
		return deleteButtonWrapper;
	}

	render() {
		return html`
		<slot></slot>
		<row-wrapper data-add-button="true">
			<button-field .onClickHandler="${this.addAdminPartingField.bind(this)}">
				<i class="fa fa-plus"></i><span>&nbsp;${this.buttonLabel}</span>
			</button-field>
		</row-wrapper>
    `;
	}
	
	isTransient (){
		return false;
	}
	
	getValues (){
		return {
			"count" : this.partingAdmins.length || 1,
			... super.getValues ()
		}
	}

	setValues (values){
		while (this.partingAdmins.length < values.count)
	        this.addAdminPartingField ();
		super.setValues (values);
	}
}

customElements.define("admin-parting-list", AdminPartingList);
